export default "__VITE_ASSET__D1IiRlY1__"